export function Event() {
  return (
    <section id="event" className="py-32 bg-black relative overflow-hidden">
      <div className="absolute inset-0">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gradient-to-r from-pink-500/10 via-purple-500/10 to-blue-500/10 rounded-full blur-3xl"></div>
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="text-center space-y-8">
          <span className="inline-block px-6 py-2 rounded-full bg-gradient-to-r from-pink-500/20 via-purple-500/20 to-blue-500/20 border border-blue-500/30 text-blue-400 text-sm font-semibold tracking-wider">
            UPCOMING EVENTS
          </span>

          <h2 className="text-7xl lg:text-9xl font-black tracking-wider" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
            <span className="bg-gradient-to-r from-pink-400 via-purple-400 to-blue-400 bg-clip-text text-transparent">
              COMING
            </span>
            <br />
            <span className="text-white/20">SOON</span>
          </h2>

          <p className="text-xl text-gray-400 max-w-xl mx-auto">
            現在、新しいイベントを企画中です。<br />
            最新情報はSNSでお知らせします。
          </p>

          <div className="flex justify-center gap-6 pt-8">
            <a
              href="#"
              className="w-14 h-14 flex items-center justify-center rounded-full bg-gray-900 border border-gray-800 text-gray-400 hover:text-pink-400 hover:border-pink-500/50 transition-all cursor-pointer"
            >
              <i className="ri-instagram-line text-2xl"></i>
            </a>
            <a
              href="#"
              className="w-14 h-14 flex items-center justify-center rounded-full bg-gray-900 border border-gray-800 text-gray-400 hover:text-purple-400 hover:border-purple-500/50 transition-all cursor-pointer"
            >
              <i className="ri-twitter-x-line text-2xl"></i>
            </a>
            <a
              href="#"
              className="w-14 h-14 flex items-center justify-center rounded-full bg-gray-900 border border-gray-800 text-gray-400 hover:text-blue-400 hover:border-blue-500/50 transition-all cursor-pointer"
            >
              <i className="ri-tiktok-line text-2xl"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
